/**
 * Copyright (c) 2021-2024 Kognitos, Inc. All rights reserved.
 */

import useDepartment from './useDepartment';
import useFeatureFlag from './useFeatureFlag';

const useALCFlag = () => {
  const { department } = useDepartment();

  const [{ rolloutAlc }] = useFeatureFlag({
    context: { department: { key: department?.id, dept_id: department?.id } }
  });

  return { isALCEnabled: rolloutAlc };
};

export default useALCFlag;
